import createValidador from '../hooks/createValidador'

const MAXIMO_DESCUENTO = 99
const MAXIMO_DESCRIPCION = 1000

export const getEsquema = () => {
  const { Validador } = createValidador()

  return {
    titulo: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': (
            <>
              Ups, te olvidaste de completar el título de tu publicación!
              <br />
              Asegúrate de tener un buen título así el comprador podrá encontrar rápidamente tu
              producto.
            </>
          )
        })
      }),
    descripcion: Validador.Kernel.string()
      .trim()
      .required()
      .max(MAXIMO_DESCRIPCION)
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': (
            <>
              Ups, te olvidaste de completar la descripción del producto! <br />
              Asegúrate de tener una buena descripción así el comprador sabrá exactamente qué está
              comprando.
            </>
          ),
          'string.max': (
            <>La descripción es demasiado larga. El máximo permitido es de 1000 caracteres.</>
          )
        })
      }),
    desde: Validador.Kernel.date()
      .min(new Date(Validador.fechaActual))
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'date.base': <>Ups, debe seleccionar la {'"Fecha Desde"'}</>,
          'date.min': <>Ups, {'"Fecha Desde"'} debe ser mayor o igual a la de hoy</>
        })
      }),
    hasta: Validador.Kernel.date()
      .min(Validador.Kernel.ref('desde'))
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'date.base': <>Ups, debe seleccionar la {'"Fecha Hasta"'}</>,
          'date.min': (
            <>
              Ups, {'"Fecha Hasta"'} debe ser mayor o igual a {'"Fecha Desde"'}
            </>
          )
        })
      }),
    idCategoria: Validador.Kernel.number()
      .empty(0)
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe seleccionar una Categoría</>
        })
      }),
    esNuevo: Validador.Kernel.any()
      .empty(null)
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe indicar si es Nuevo o Usado</>
        })
      }),
    cantDisponible: Validador.Kernel.when('conPresupuesto', {
      is: false,
      then: Validador.Kernel.number()
        .empty(0)
        .min(1)
        .required()
        .error((e) => {
          return Validador.mensaje(e, {
            'any.empty': <>Ups, Cantidad Disponible debe ser mayor a cero</>,
            'any.required': <>Ups, Cantidad Disponible debe ser mayor a cero</>,
            'number.min': <>Ups, Cantidad Disponible debe ser mayor a cero</>
          })
        })
    }),
    idMoneda: Validador.Kernel.when('conPresupuesto', {
      is: false,
      then: Validador.Kernel.number()
        .empty(0)
        .required()
        .error((e) => {
          return Validador.mensaje(e, {
            'any.empty': <>Ups, Debe seleccionar una moneda</>,
            'any.required': <>Ups, Debe seleccionar una moneda</>
          })
        })
    }),
    precioUnitario: Validador.Kernel.when('conPresupuesto', {
      is: false,
      then: Validador.Kernel.number()
        .empty(0)
        .min(1)
        .required()
        .error((e) => {
          return Validador.mensaje(e, {
            'any.empty': <>Ups, Precio Minorista debe ser mayor a cero</>,
            'any.required': <>Ups, Precio Minorista debe ser mayor a cero</>,
            'number.min': <>Ups, Precio Minorista debe ser mayor a cero</>
          })
        })
    }),
    porcDcto: Validador.Kernel.number()
      .min(0)
      .max(MAXIMO_DESCUENTO)
      .error((e) => {
        return Validador.mensaje(e, {
          'number.min': <>Ups, el {'"Porcentaje de descuento"'} es incorrecto</>,
          'number.max': <>Ups, el {'"Porcentaje de descuento"'} es incorrecto</>
        })
      }),
    ofertaDesde: Validador.Kernel.when('porcDcto', {
      is: 0,
      then: Validador.Kernel.date(),
      otherwise: Validador.Kernel.date().min(Validador.Kernel.ref('desde')).required()
    })
      .empty(null)
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe seleccionar {'"Fecha de Inicio"'}</>,
          'date.min': (
            <>Ups, la {'"Fecha de Inicio"'} no puede ser anterior a la fecha de la publicación</>
          )
        })
      }),
    ofertaHasta: Validador.Kernel.when('porcDcto', {
      is: 0,
      then: Validador.Kernel.date(),
      otherwise: Validador.Kernel.date()
        .min(Validador.Kernel.ref('ofertaDesde'))
        .max(Validador.Kernel.ref('hasta'))
        .required()
    })
      .empty(null)
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe seleccionar {'"Fecha de Finalización"'}</>,
          'date.min': (
            <>
              Ups, la {'"Fecha de Finalización"'} no puede ser anterior a la
              {'"Fecha de Inicio"'}
            </>
          )
        })
      }),
    idPublicacionExposicion: Validador.Kernel.number()
      .empty(0)
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe indicar el Tipo de Exposición</>
        })
      }),
    extensionGarantia: Validador.Kernel.boolean()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe indicar si tiene extensión de garantía</>
        })
      }),
    mediosPagos: Validador.Kernel.array()
      .required()
      .min(1)
      .error((e) =>
        Validador.mensaje(e, {
          'array.min': <>Debe seleccionar al menos un medio de pago</>
        })
      ),
    mediosEnvios: Validador.Kernel.array()
      .required()
      .min(1)
      .error((e) =>
        Validador.mensaje(e, {
          'array.min': <>Debe seleccionar al menos un medio de envío</>
        })
      ),
    alicuota: Validador.Kernel.number()
      .empty(null)
      .required()
      .min(0)
      .max(100)
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': <>Ups, debe seleccionar una alícuota</>,
          'any.required': <>Ups, debe seleccionar una alícuota</>,
          'number.min': <>Ups, la alícuota no puede ser negativa</>,
          'number.max': <>Ups, la alícuota no puede ser mayor a 100</>
        })
      }),
    cantDiasRetiroComprador: Validador.Kernel.number()
      .min(0)
      .when('tieneRetiro', {
        is: true,
        then: Validador.Kernel.required(),
        otherwise: Validador.Kernel.allow(null)
      })
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debes completar los días de retiro</>,
          'number.min': <>Ups, la cantidad de días de retiro no puede ser menor a 0</>,
          'number.base': <>Ups, la cantidad de días de retiro debe ser un número válido</>
        })
      }),
    descZonaRetiro: Validador.Kernel.string()
      .trim()
      .when('tieneRetiro', {
        is: true,
        then: Validador.Kernel.required(),
        otherwise: Validador.Kernel.allow(null, '')
      })
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debes completar las zonas de retiro para el comprador</>,
          'any.empty': (
            <>
              Ups, te olvidaste de completar las zonas de retiro para el comprador! <br />
              Asegúrate de completar este campo para que el comprador sepa en que zonas puede
              retirar el producto.
            </>
          ),
          'string.base': <>Ups, las zonas de retiro deben ser un texto válido</>
        })
      }),
    cantDiasEnvioGratis: Validador.Kernel.number()
      .min(0)
      .when('tieneEnvioGratis', {
        is: true,
        then: Validador.Kernel.required(),
        otherwise: Validador.Kernel.allow(null)
      })
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debes completar los días de envío gratis</>,
          'number.min': <>Ups, la cantidad de días de envío gratis no puede ser menor a 0</>,
          'number.base': <>Ups, la cantidad de días de envío gratis debe ser un número válido</>
        })
      }),
    descZona: Validador.Kernel.string()
      .trim()
      .when('tieneEnvioGratis', {
        is: true,
        then: Validador.Kernel.required(),
        otherwise: Validador.Kernel.allow(null, '')
      })
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debes completar las zonas de envío gratis</>,
          'any.empty': (
            <>
              Ups, te olvidaste de completar las zonas con envío gratis! <br />
              Asegúrate de completar este campo para que el comprador sepa a qué zonas realizas
              envíos gratis.
            </>
          ),
          'string.base': <>Ups, las zonas de envío gratis deben ser un texto válido</>
        })
      })
  }
}
